import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.333 2.667A5.332 5.332 0 0 1 14.667 8a5.332 5.332 0 0 1-5.334 5.333H6.667A5.332 5.332 0 0 1 1.333 8a5.332 5.332 0 0 1 5.334-5.333h2.666Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.333 10.667a2.667 2.667 0 1 1 0-5.333 2.667 2.667 0 0 1 0 5.333Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
